export default __webpack_public_path__ + "static/media/profile3.fbffed29.png";